/**
 * Chip-urile de categorie de pe pagina de colecție.
 *
 * Fără JS sunt linkuri normale care merg la URL-ul filtrat — funcționează, dar
 * reîncarcă pagina. Aici le legăm de bifele din bara laterală: apăsarea unui
 * chip comută bifa corespunzătoare și lasă componenta de filtre a temei să facă
 * actualizarea fără reîncărcare, exact ca atunci când bifezi din stânga.
 */
const CHIP = '[data-dxd-chip]';

/** Bifele filtrului, din formularul de desktop dacă există. */
function inputsFor(param) {
  const all = [...document.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(param)}"]`)];
  const desktop = all.filter((i) => i.closest('.facets--vertical'));
  return desktop.length ? desktop : all;
}

function activeValues(param) {
  return new URLSearchParams(window.location.search).getAll(param);
}

/** Aduce starea vizuală a chip-urilor în acord cu URL-ul curent. */
function syncChips() {
  const chips = [...document.querySelectorAll(CHIP)];
  if (!chips.length) return;

  const param = chips[0].dataset.dxdParam;
  if (!param) return;

  const active = activeValues(param);

  for (const chip of chips) {
    const isAll = chip.hasAttribute('data-dxd-chip-all');
    const on = isAll ? active.length === 0 : active.includes(chip.dataset.dxdValue);
    chip.classList.toggle('dxd-chip--active', on);
    if (on && !isAll) chip.setAttribute('aria-current', 'true');
    else chip.removeAttribute('aria-current');
  }
}

document.addEventListener('click', (event) => {
  const chip = event.target.closest(CHIP);
  if (!chip) return;

  const param = chip.dataset.dxdParam;
  if (!param) return;

  const inputs = inputsFor(param);
  if (!inputs.length) return; // fără bife în pagină, lăsăm linkul să navigheze

  event.preventDefault();

  if (chip.hasAttribute('data-dxd-chip-all')) {
    const checked = inputs.filter((i) => i.checked);
    if (!checked.length) return;
    checked.forEach((i) => {
      i.checked = false;
    });
    // Un singur eveniment: componenta de filtre citește oricum tot formularul.
    checked[0].dispatchEvent(new Event('change', { bubbles: true }));
  } else {
    const input = inputs.find((i) => i.value === chip.dataset.dxdValue);
    if (!input) {
      window.location.href = chip.href;
      return;
    }
    input.checked = !input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Tema rescrie URL-ul după ce termină; resincronizăm de câteva ori.
  [120, 400, 900].forEach((delay) => window.setTimeout(syncChips, delay));
});

window.addEventListener('popstate', syncChips);
document.addEventListener('DOMContentLoaded', syncChips);
syncChips();
